import { flow, find, curry, get } from 'lodash/fp';

export default curry((surcharge, designId, allItems) => flow(
  get(designId),
  get('pricingResult.charges'),
  find({ specName: surcharge }),
)(allItems));
